import { keyframes } from '@emotion/react'

export default {
  backgroundColor: 'white15',
  borderRadius: '4.5rem',
  opacity: '0.5',
  animation: `${keyframes({ '50%': { opacity: '1' } })} 3s 3s backwards infinite`,
}
